var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-container"},[_c('bryntum-grid',_vm._b({ref:"groupGrid",attrs:{"data":_vm.data}},'bryntum-grid',_vm.GroupGridConfig,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }